import { useState } from "react";
import { post } from "../networking/RequestService";
import { toast } from "react-toastify";
import { apiErrorText } from "app/popleads/networking/apiErrorText";

const useNotSil = (profileId) => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const notSil = async ({ noteId }) => {
        setLoading(true);
        setError(null);

        try {
            const payload = {
                fn: "notSil",
                profil: profileId,
                not: noteId,
            };
            await post(payload);
            toast.success("Note deleted successfully");
        } catch (err) {
            toast.error(apiErrorText(err));
        } finally {
            setLoading(false);
        }
    };

    return { notSil, loading, error };
};

export default useNotSil;
